export default __webpack_public_path__ + "static/media/pizza-logo.56ac8703.svg";